"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationsClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class IntegrationsClient extends authenticated_client_1.AuthenticatedClient {
    findAll(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/integrations`);
            return response.payload;
        });
    }
    findById(projectId, integrationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/integrations/${integrationId}`);
            return response.payload;
        });
    }
    create(projectId, integration) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/integrations`, integration);
            return response.payload;
        });
    }
    update(projectId, integrationId, integration) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/integrations/${integrationId}`, integration);
            return response.payload;
        });
    }
    delete(projectId, integrationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`/v1/projects/${projectId}/integrations/${integrationId}`);
            return response.payload;
        });
    }
    checkCredentials(projectId, adobeRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/integrations/provider-check-credentials`, adobeRequestModel);
            return response.payload;
        });
    }
    getVars(projectId, adobeRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/integrations/provider-vars`, adobeRequestModel);
            return response.payload;
        });
    }
    getSegments(projectId, integrationRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/integrations/provider-segments`, integrationRequestModel);
            return response.payload;
        });
    }
}
exports.IntegrationsClient = IntegrationsClient;
//# sourceMappingURL=integrations.client.js.map